import React from "react";
import styles from "./TripDetails.module.css";
import { useTranslation } from "react-i18next";

// Helper function to get the count of keys in an object that match a specific tripProgramId
const getFilteredKeyCount = (obj, tripProgramId) => {
  if (!obj || typeof obj !== "object" || obj === null) {
    return 0;
  }
  return Object.keys(obj).filter(
    (key) => obj[key].tripProgramId === tripProgramId
  ).length;
};

// Main component
const AcquisitionsHelper = ({ tripProgramId, acquisitions }) => {
  const { t } = useTranslation(); // Hook to get translation function

  // Count the number of keys in activity and option that match the tripProgramId
  const activityCount = getFilteredKeyCount(
    acquisitions?.activity,
    tripProgramId
  );
  const optionCount = getFilteredKeyCount(acquisitions?.option, tripProgramId);

  // Render nothing if both counts are zero
  if (activityCount === 0 && optionCount === 0) {
    return null; // Don't render anything
  }

  // Prepare the output message based on the counts
  let output = t("Vous avez choisi") + " ";

  if (activityCount > 0 && optionCount > 0) {
    output += `${activityCount} ${t("Activités")} ${t("et")} ${optionCount} ${t(
      "Option"
    )}`;
  } else if (activityCount > 0) {
    output += `${activityCount} ${t("Activités")}`;
  } else if (optionCount > 0) {
    output += `${optionCount} ${t("Option")}`;
  }

  // Render the output
  return <p className={styles.info_activities_options}>{output}</p>;
};

export default AcquisitionsHelper;
